import { api } from '@services';
import TagCategory, {
  CategoryColor,
  ITagCategory,
  ITagCategoryApiModel,
} from '@models/TagCategory.model';

interface ICreateTagCategory {
  name: string;
  description?: string;
  showOnOnboard?: boolean;
  isUnique?: boolean;
  color?: CategoryColor;
}

const createTagCategory = async (
  data: ICreateTagCategory,
): Promise<ITagCategory> => {
  const { data: tagsCategory } = await api.post<ITagCategoryApiModel>(
    '/tagsCategory',
    data,
  );
  return TagCategory.fromApiModel(tagsCategory);
};

export { createTagCategory };
